import React, { useContext } from 'react';
import Helmet from 'react-helmet-async';
import ChannelContext from './ChannelContext';
import qs from 'qs';
import useWarningInDev from '../hooks/useWarningInDev';
function renderAlternateRoutes(alternateRoute, channelsById) {
    const url = channelsById[alternateRoute.channelId].url;
    const route = alternateRoute.route;
    const query = qs.stringify({
        culture: alternateRoute.culture,
        channeL: channelsById[alternateRoute.channelId].name
    }, { addQueryPrefix: true });
    const href = `${url}${route}${query}`;
    return (React.createElement("link", { key: href + alternateRoute.culture, rel: "alternate", href: href, hrefLang: alternateRoute.culture }));
}
const Head = ({ data, route }) => {
    const { selectedChannel, channelsById } = useContext(ChannelContext);
    const lang = selectedChannel.language.culture.split('-')[0];
    const metaTags = data.metaTags || [];
    const href = route &&
        route.canonicalPath &&
        `${selectedChannel.url}${route.canonicalPath}`;
    useWarningInDev(route && !route.alternateRoutes, `You must include the RouteCrumbFragment in your RouteQuery.gql
    Please see https://gitlab.jetshop.se/jetshop/flight/blob/master/packages/template-trend/src/components/RouteQuery.gql for an example
    `);
    return (React.createElement(Helmet, null,
        React.createElement("html", { lang: lang }),
        React.createElement("title", null, data.title),
        metaTags.map(tag => (React.createElement("meta", { name: tag.name, content: tag.content, key: tag.name }))),
        route &&
            route.alternateRoutes &&
            route.alternateRoutes.map(alternateRoute => renderAlternateRoutes(alternateRoute, channelsById)),
        href && React.createElement("link", { rel: "canonical", href: href })));
};
export default Head;
//# sourceMappingURL=Head.js.map